/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Hex from 'solis/type/hex';
import HexGroup from 'solis/type/hex/group';


const VARIANTS_5 =
[
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2) ]),
];


const VARIANTS_7 =
[
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-2), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-1) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-1), new Hex( 1,-2) ]),
];


const VARIANTS_9 =
[
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex(-2,-4), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex(-1,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex(-1,-4), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex(-1,-4), new Hex( 0,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex(-1,-4), new Hex( 1,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 0,-3), new Hex( 0,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 1,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-2), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex(-2,-3), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex(-1,-4), new Hex( 0,-3), new Hex( 0,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 0,-3), new Hex( 0,-4), new Hex( 1,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 1,-2), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 1,-2), new Hex( 2,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-2), new Hex( 0,-3), new Hex( 0,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-1), new Hex( 1,-2), new Hex( 0,-3), new Hex( 1,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-1), new Hex( 1,-2), new Hex( 0,-3), new Hex( 2,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-1), new Hex( 1,-2), new Hex( 2,-2), new Hex( 1,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-2), new Hex( 0,-3), new Hex( 2,-2), new Hex( 1,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 0,-3), new Hex( 0,-4) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 1,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-2), new Hex( 0,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex( 1,-2), new Hex( 0,-3), new Hex( 1,-3) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex(-1,-2), new Hex( 1, 1), new Hex( 1, 0), new Hex( 0,-1), new Hex( 0,-2), new Hex( 2, 0), new Hex( 1,-1) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex( 0,-1), new Hex( 0,-2), new Hex(-1,-3), new Hex( 1,-1), new Hex( 1,-2), new Hex( 0,-3), new Hex( 2,-2) ]),
  new HexGroup([ new Hex( 0, 0), new Hex(-1,-1), new Hex( 1, 1), new Hex( 1, 0), new Hex( 0,-1), new Hex( 2, 0), new Hex( 1,-1), new Hex( 1,-2), new Hex( 2,-2) ]),
];


export const getVariants = (size) =>
{
  switch (size)
  {
    case 5:  return VARIANTS_5;
    case 7:  return VARIANTS_7;
    case 9:  return VARIANTS_9;

    default: throw new Error('Unsupported variant size');
  }
};


export const getVariantCount = (size) =>
{
  return getVariants(size).length;
};


export const getVariant = (size, variant) =>
{
  return getVariants(size)[variant];
};
